<template>
    <template v-if="shouldRender">
        <slot></slot>
    </template>
</template>

<script>
    import { h } from 'vue'

    export default {
        data() {
            return {
                shouldRender: false,
            };
        },
        mounted() {
            this.shouldRender = true;
        }
    }
</script>
